/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import cn from "classnames";

import styles from "./styles.scss";

const Banner = ({ className }: { className?: string }) => {
  const t = useTranslate();

  return (
    <div className={cn(styles.block, className)}>
      <span className={styles.eurobonus}>{t("HEADER.SHOPNAME")}</span>
    </div>
  );
};

export default Banner;
